module.exports = "/assets/data/b372ad9dcd5bc984f1aa8c4f6e132849-GL5.data.json";